var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-file-input',{attrs:{"hide-input":"","multiple":"","prepend-icon":"mdi-paperclip"},on:{"change":_vm.addAttachment},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }